import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-audit-logs',
  templateUrl: './audit-logs.component.html',
  styleUrls: ['./audit-logs.component.scss']
})
export class AuditLogsComponent implements OnInit {

  constructor() { }
  @Input() data: any;
  ngOnInit() {
  }

}
